<confirmaciongenerica #appconfirmacioneliminar (ConfirmoUsuario)="ConfirmoEliminarUsuario($event)" [TextoSiMostrar]="'Aceptar'" [TextoNoMostrar]="'Cancelar'"></confirmaciongenerica>
<mat-progress-bar color="primary" mode="indeterminate" *ngIf="mostrarCargando"></mat-progress-bar>
<div class="row mt-5">
    <div class="d-flex justify-content-between">
        <div>
            <h2 class="titleppal">{{this.TituloOpcionMenu()}}</h2>
            <div class="line">
                <div class="line2"></div>
            </div>
        </div>
        <div class="botoncerrar">
            <a type="button" (click)="CancelarRegistro()">
                <mat-icon aria-hidden="false">close</mat-icon>
            </a>
        </div>
    </div>
    <div class="d-flex justify-content-between flex-wrap filtrosTable align-items-center" autocomplete="off">
        <div [formGroup]="form" class="d-flex flex-wrap" autocomplete="off">
            <div class="p-1">
                <h2>Aquí los datos del <br *ngIf="this.tamanoAppService.mostrarModoEscritorio"/> afiliado</h2>
            </div>
            <div class="p-1">
                <mat-form-field appearance="fill" [style.width.%]="this.AnchoCampoBusqueda()">
                    <mat-label>Número de identificacion, poliza, contrato, placa...</mat-label>
                    <input matInput formControlName="nroDocumento" autocomplete="off" (keyup.enter)="ConsultarAfiliados()">
                    <button (click)="ConsultarAfiliados()" mat-icon-button matSuffix type="button">
                        <mat-icon>search</mat-icon>
                    </button>
                    <mat-error *ngIf="form.get('nroDocumento').hasError('required')">El Numero de identificacion es un campo requerido</mat-error>
                </mat-form-field>
            </div>
        </div>
        <div>
            <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 20, 30, 40, 50]" aria-label="Select page of users"></mat-paginator>
        </div>
    </div>

    <div class="pl-0 pr-0 mat-elevation-z8">
        <div class="table-responsive">
            <table mat-table [dataSource]="dataSource" matSort class="table table-striped table-hover">

                <!-- nroDocumento Column -->
                <ng-container matColumnDef="nroDocumento">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Número de documento</th>
                    <td mat-cell *matCellDef="let row"> {{row.nroDocumento}} </td>
                </ng-container>

                <!-- activo Column -->
                <ng-container matColumnDef="activo">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Estado </th>
                    <td mat-cell *matCellDef="let row">
                        <a type="button" (click)="abrirDetalleEstadoAfiliado(row)">
                            <p *ngIf="row.estadoColor === 'txtActivo'"><img src="assets/img/activo.svg"></p>
                            <p *ngIf="row.estadoColor === 'txtInactivo'"><img src="assets/img/inactivo.svg"></p>
                            <p *ngIf="row.estadoColor === 'txtBloqueado'"><img src="assets/img/bloqueado.svg"></p>
                        </a>
                    </td>
                </ng-container>

                <!-- fechaAfiliacion Column -->
                <ng-container matColumnDef="fechaAfiliacion">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha afiliación </th>
                    <td mat-cell *matCellDef="let row"> {{row.fechaAfiliacion | fechapipe}} </td>
                </ng-container>

                <!-- nombresApellidos Column -->
                <ng-container matColumnDef="nombresApellidos">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre y apellido </th>
                    <td mat-cell *matCellDef="let row"> {{row.nombresApellidos}} </td>
                </ng-container>

                <!-- canal Column -->
                <ng-container matColumnDef="canal">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Canal </th>
                    <td mat-cell *matCellDef="let row"> {{row.canal}} </td>
                </ng-container>

                <!-- aliado Column -->
                <ng-container matColumnDef="aliado">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Aliado </th>
                    <td mat-cell *matCellDef="let row"> {{row.aliado}} </td>
                </ng-container>

                <!-- producto Column -->
                <ng-container matColumnDef="producto">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Producto </th>
                    <td mat-cell *matCellDef="let row"> {{row.producto}} </td>
                </ng-container>

                <!-- fechaBaja Column -->
                <ng-container matColumnDef="fechaBaja">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha baja </th>
                    <td mat-cell *matCellDef="let row"> {{row.fechaBaja | fechapipe}} </td>
                </ng-container>

                <!-- acciones Column -->
                <ng-container matColumnDef="acciones">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Acciones </th>
                    <td mat-cell *matCellDef="let row">
                        <a type="button" (click)="abrirDetalleAfiliado(row)" class="icnTable">
                            <mat-icon>remove_red_eye</mat-icon>
                        </a>
                        <a type="button" target="_blank" [href]="row.rutaTerminosCondiciones" class="icnTable" *ngIf="MostrarTerminosCondiciones(row) && this.PermitirEditarRegistro(row)">
                            <mat-icon>find_in_page</mat-icon>
                        </a>
                        <a type="button" target="_blank" [href]="row.rutaControlOperaciones" class="icnTable" *ngIf="MostrarControlOperaciones(row) && this.PermitirEditarRegistro(row)">
                            <mat-icon>info</mat-icon>
                        </a>
                        <a type="button" (click)="abrirDetalleCartera(row)" class="icnTable" *ngIf="row.manejaCartera && this.PermitirEditarRegistro(row)">
                            <mat-icon>attach_money</mat-icon>
                        </a>
                        <a type="button" (click)="abrirEdicionValoresDetalleRegistro(row)" class="icnTable" *ngIf="this.PermitirEditarValoresRegistro(row)">
                            <mat-icon>edit</mat-icon>
                        </a>
                        <a type="button" (click)="ejecutarEliminarRegistro(row)" class="icnTable" *ngIf="this.HabilitarEliminarRegistro()">
                            <mat-icon>delete</mat-icon>
                        </a>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="columnasEncabezado"></tr>
                <tr mat-row *matRowDef="let row; columns: columnasEncabezado;"></tr>

                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="9">No existen datos con el filtro indicado </td>
                </tr>
            </table>
        </div>
    </div>
</div>